(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["heading-callout"] && !Shopify.designMode) return;
  try {
    (function() {
    function processCalloutTransitions() {
      const containers = document.querySelectorAll('[data-heading-callout-container]');
      
      containers.forEach(function(container) {
        // Find any remaining parentheses text that wasn't replaced (fallback)
        const html = container.innerHTML;
        const parenPattern = /\([^)]+\)/g;
        const matches = html.match(parenPattern);
        
        if (matches) {
          let processedHtml = html;
          matches.forEach(function(match) {
            // Only wrap if it's not already inside a callout
            if (!match.includes('heading-callout') && !match.includes('callout-placeholder')) {
              const placeholder = '<span class="callout-placeholder">' + match + '</span>';
              processedHtml = processedHtml.replace(match, placeholder);
            }
          });
          
          if (processedHtml !== html) {
            container.innerHTML = processedHtml;
          }
        }
        
        // Animate callouts that are already in place (from server-side replacement)
        const callouts = container.querySelectorAll('.heading-callout');
        callouts.forEach(function(callout) {
          // Add animation class if not already animated
          if (!callout.classList.contains('callout-animated')) {
            callout.classList.add('callout-animated');
          }
        });
      });
    }
    
    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processCalloutTransitions);
    } else {
      processCalloutTransitions();
    }
    
    // Run when theme editor updates
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', processCalloutTransitions);
      document.addEventListener('shopify:block:select', processCalloutTransitions);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
